// EXPERIMENT: psf_featured_spiking_petition_experiment — remove with experiment cleanup
import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'psf-featured-petition',
		path: '/p/:slug/psf/featured-petition',
		component: loadable(async () => import(/* webpackChunkName: "pages/psf-featuredPetition" */ './index'), {
			exportName: 'PsfFeaturedPetition',
			fallback: Loading,
		}),
		frame: false,
		ssr: {
			enabled: true,
			seo: false,
			// Same as the other PSF pages: navigation to and from this page is external
			isolated: true,
		},
	},
];
